import { gql } from "@apollo/client";

export const addUserAndLicense = gql`
  mutation addUserAndLicense($input: AddOrUpdateUserAndLicenseInput!) {
    user_AddOrUpdate(input: $input) {
        _id
    }
  }
`;